module.exports = __webpack_public_path__ + "img/LV4.8be4ff6a.webp";